import { render, staticRenderFns } from "./LunchOrder.vue?vue&type=template&id=ab5b56b8&scoped=true"
import script from "./LunchOrder.vue?vue&type=script&lang=js"
export * from "./LunchOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5b56b8",
  null
  
)

export default component.exports